import ClickSwitch from './ClickSwitch';
import { setupSmoothScroll,setupAccordions } from './_include';

// slickでswipe中にmodaalが表示されるのを回避するための判定用変数
let swiping = false;

// ------------------------------
// 360px以下viewport固定
// ------------------------------
!(function () {
  const viewport = document.querySelector('meta[name="viewport"]');
  function switchViewport() {
    const value =
      window.outerWidth > 360
        ? 'width=device-width,initial-scale=1'
        : 'width=360';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  window.addEventListener('resize',debounce(switchViewport));
  switchViewport();
})();

// ------------------------------
// resizeやscrollイベントの実行頻度削減
// ------------------------------

function debounce(func, timeout) {
  let timer;
  timeout = timeout !== undefined ? timeout : 300; // funcが呼び出されるまでの遅延時間
  return () => {
    const context = this;
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(context, args);
    }, timeout);
  };
}

// ------------------------------
// modaal
// ------------------------------
$(() => {
  $('[class*="js-modal-"]').each((i, e) => {
    const $e = $(e);

    const modalOptions = {
      animation_speed: 100,
    };

    if ($e.hasClass('js-modal-youtube')) {
      if (!$e.attr('href')) {
        $e.attr('href',
          `https://www.youtube-nocookie.com/embed/${$e.attr('data-youtube')}?autoplay=1&mute=1&rel=0`
        );
      }
      modalOptions.type = 'video';
    }

    if ($e.hasClass('js-modal-img')) {
      modalOptions.type = 'image';
      modalOptions.should_open = function() {
        if (swiping) return false;
        return true;
      };
    }

    if ($e.hasClass('js-modal-inline')) {
      modalOptions.type = 'inline';
    }

    if ($e.hasClass('js-modal-start')) {
      modalOptions.start_open = true;
    }

    $e.modaal(modalOptions);
  });
});

// ------------------------------
// smooth scroll
// ------------------------------
function initSmoothScroll() {
  $('a[href*="#"]:not([class*="js-"])').each((i, elem) => {
    setupSmoothScroll(elem,{buffer:document.querySelector('header').offsetHeight});
  })
}

$(() => {
  initSmoothScroll();
})


// ------------------------------
// slick
// ------------------------------
$(() => {
  const $slide = $('.js-slider');
  let w = 1200; // PC版アートボードカンプサイズ


  if ($slide.length <= 0) {
    return false;
  }
  for (const slide of $slide) {
    const type = $(slide).data('type');
    let defaultOptions = {
      dots: true,
      arrows: false,
    };
    let options = { ...defaultOptions };

    switch (type) {
      case 'main':
        options = {
          ...defaultOptions,
          centerMode: true,
          centerPadding: (275 / w) * 100 + 'vw',
          slidesToShow: 1,
          autoplaySpeed: 3000,
          autoplay: $(slide).find('img').length > 1 ? true : false,
          variableWidth: true,
          responsive: [{
            breakpoint: 767,
            settings: {
              centerPadding: '25px',
              variableWidth: false,
            }
          }]
        }
        $(slide).slick(options);
        const updateSlickControl = () => {
          const $controllDiv = $('<div>', {class: 'slick-control'});
          // スライダーの最後に追加
          $(slide).append($controllDiv);
          // .slick-dots と .slick-autoplay-toggle-button を slick-controll 内に移動
          $(slide).find('.slick-dots, .slick-autoplay-toggle-button').appendTo($controllDiv);
        }
        updateSlickControl();
        $(slide).on('breakpoint',function(){
          updateSlickControl();
          initSmoothScroll();
        })
        break;

        default:
        options = {
          ...defaultOptions,
          speed: 200,
        }
        $(slide).slick(options);
    }


    // クローンのdata-group属性外す
    $(slide).find('.slick-cloned a').removeAttr('data-group');

    // swipe中にmodaal.jsが実行されるのを回避
    // スライド切り替え前にフォーカスを解除
    $(slide).on(
      {
        'swipe': function (event, slick, direction) {
          swiping = true;
        },
        'afterChange': function (event, slick, currentSlide) {
          swiping = false;
        },
        'beforeChange':function(event, slick, currentSlide, nextSlide) {
          if (document.activeElement) {
            document.activeElement.blur();
          }
        }
      }
    );

  }
});


// ------------------------------
// アコーディオンの設定
// ------------------------------

$(()=>{
  // officialページでは js-details2 を使うので除外
  const accordions = $('.js-details').not('.js-details2');
  setupAccordions(accordions);
});

$(() => {
  const $accordions = $('.js-details2');
  let isAccordionInitialized = false;

  function handleAccordion() {

    const isPC = window.matchMedia('(min-width: 768px)').matches;

    if (isPC) {
      // PCは全部開く＆イベント解除
      $accordions.each(function () {
        $(this).attr('open', true);
      });

      if (isAccordionInitialized) {
        $accordions.off(); // イベント解除
        isAccordionInitialized = false;
      }

    } else {
      // SPだけ一度だけ初期化
      if (!isAccordionInitialized) {
        setupAccordions($accordions);
        isAccordionInitialized = true;
      }
    }
  }

  handleAccordion();

  $(window).on('resize', function () {
    handleAccordion();
  });

});
// ------------------------------
// ハンバーガーメニュー
// ------------------------------
$(() => {
  // ハンバーガーメニューのインスタンス生成
  const hamburger = new ClickSwitch({
    trigger: document.querySelector('.js-hamburger-trigger'),
    targets: Array.from(document.querySelectorAll('.js-hamburger-target')),
    setAriaLabels: false,
    onActive: (trigger, targets) => {
      trigger.querySelector('span').textContent = '商品別メニューを閉じる';
    },
    onDefault: (trigger, targets) => {
      trigger.querySelector('span').textContent = '商品別メニューを開く';
    }
  })

  // 初期化
  hamburger.toDefault()
})


// ------------------------------
// select2
// ------------------------------
$(() => {
  $('.js-select').select2({
    minimumResultsForSearch: -1,
    width:'auto'
  })
})


// ------------------------------
// math-height
// ------------------------------
$(() => {
  $('.js-match-height').matchHeight();
});
